import { REGISTER, LOGIN, KYC, LOGOUT } from "../actions/types";
import history from "../../helpers/history";

let user = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : {};
let loggedIn = user.token ? true : false;
// console.log(user.token)

// console.log(user)
const initialState = { registered: false, loggedIn, user, kyc: 0 };

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER.SETUSER:
    case LOGIN.SETUSER:
      // console.log(action.payload)
      const user = action.payload.result;
      localStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("e", "1");

      if (action.payload.flag === 1) {
        return { ...state, user, registered: true };
      }
      return { ...state, user, loggedIn: true };

    case LOGIN.LOGOUT:
      localStorage.removeItem("user");
      sessionStorage.removeItem("e");
      localStorage.clear();
      sessionStorage.clear()
      history.push("/login");

      return { ...state, user: {}, loggedIn: false };
    case KYC.SUCCESS:
      let flag = action.payload;
      sessionStorage.setItem("kyc",flag)
      localStorage.setItem("kyc",flag)

      return { ...state, kyc: flag };

    case KYC.FAILURE:
      return { ...state, kyc: false };

    case REGISTER.FAIL:
    case LOGIN.FAIL:
      return state;
    
    case LOGIN.UPDATE_USER_SUCCESS:
      return {...state, user: action.payload}

    default:
      return state;
  }
};

export default userReducer;
